<ng-template #overflowTooltip>
  <app-space-users-tooltip-content [users]="remainingUsers"></app-space-users-tooltip-content>
</ng-template>

<div *ngIf="firstUser" class="section-item">
  <div class="section-item-label">
    <svg-icon icon="user-simple" [width]="18" [height]="18"></svg-icon>
    <span>{{ label }}</span>
  </div>
  <div class="section-item-value users-list">
    <app-pencil-pill
      [text]="firstUser.name"
      [image]="firstUser.profile_image ?? ''"
      [isRemovable]="false"
    ></app-pencil-pill>
    <app-pencil-pill
      *ngIf="remainingUsers.length"
      [text]="'+' + remainingUsers.length"
      [isRemovable]="false"
      [appTooltip]="overflowTooltip"
      [appTooltipStayWhenTooltipHover]="true"
      [appTooltipPlacement]="'bottom-center'"
      [appTooltipOffsetX]="-80"
    ></app-pencil-pill>
  </div>
</div>
